import { Routes } from '@angular/router';
import { ProjectsListComponent } from "./views/projects-list/projects-list.component";
import { ProjectWelcomeComponent } from "./views/project-welcome/project-welcome.component";
import { TasksComponent } from "./views/tasks/tasks.component";
import { TaskListComponent } from "./views/task-list/task-list.component";
import { ProjectLinksComponent } from "./views/project-links/project-links.component";
import { TimeTrackingComponent } from "./views/time-tracking/time-tracking.component";
import { ProjectSettingsComponent } from "./views/project-settings/project-settings.component";
import { authGuard } from "@the-guild-llc/gatekeeper-dev";

export const routes: Routes = [
  {
    path: '',
    component: ProjectsListComponent,
    canActivate: [ authGuard ]
  },
  {
    path: ':orgId',
    children: [
      {
        path: ':projectId',
        children: [
          {
            path: '',
            component: ProjectWelcomeComponent
          },
          {
            path: 'tasks',
            children: [
              {
                path: '',
                component: TasksComponent
              },
              {
                path: 'list/:listId',
                component: TaskListComponent
              },
            ],
          },
          {
            path: 'links',
            component: ProjectLinksComponent
          },
          {
            path: 'worktime',
            component: TimeTrackingComponent,
          },
          {
            path: 'settings',
            component: ProjectSettingsComponent,
          }
        ],
      },
    ],
  },

];
